export default "__VITE_ASSET__c1h4IGet__"